import { createContext, useContext } from "react";

type DossierTraceIdContext = {
    traceId: string;
};
export const DossierTraceIdContext = createContext<DossierTraceIdContext | null>(null);

export const useDossierTraceId = () => {
    const ctx = useContext(DossierTraceIdContext);
    if (!ctx) {
        throw new Error("useDossierTraceId must be used within DossierTraceIdContext");
    }
    return ctx.traceId;
};
